import SaveInProgressIntro from 'platform/forms/save-in-progress/SaveInProgressIntro';
import { HEALTH_ENROLLMENT_STATUSES } from 'platform/shared/health-apps';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import content from '../../../../locales/en/content.json';
import { selectParsedStatus } from '../../../../selectors';

const APPLY_STATUSES = new Set([
  HEALTH_ENROLLMENT_STATUSES.activeDuty,
  HEALTH_ENROLLMENT_STATUSES.canceledDeclined,
  HEALTH_ENROLLMENT_STATUSES.closed,
  HEALTH_ENROLLMENT_STATUSES.nonMilitary,
  HEALTH_ENROLLMENT_STATUSES.rejectedIncWrongEntry,
  HEALTH_ENROLLMENT_STATUSES.rejectedRightEntry,
  HEALTH_ENROLLMENT_STATUSES.rejectedScWrongEntry,
]);

const ReapplyButton = ({ route: { formConfig, pageList } }) => {
  const parsedStatus = useSelector(selectParsedStatus);

  const hasApplyStatus = useMemo(
    () => APPLY_STATUSES.has(parsedStatus),
    [parsedStatus],
  );

  const sipProps = useMemo(
    () => ({
      startText: content['sip-start-form-text'],
      messages: formConfig.savedFormMessages,
      downtime: formConfig.downtime,
      buttonOnly: true,
      pageList,
    }),
    [formConfig, pageList],
  );

  return hasApplyStatus ? (
    <div className="vads-u-margin-top--3">
      <SaveInProgressIntro {...sipProps} />
    </div>
  ) : null;
};

ReapplyButton.propTypes = {
  route: PropTypes.shape({
    formConfig: PropTypes.shape({
      savedFormMessages: PropTypes.object,
      downtime: PropTypes.object,
    }),
    pageList: PropTypes.array,
  }),
};

export default ReapplyButton;
